export const CODE_SCANNER = {
  TITLE: 'Escáner de Código',
  CONFIGURATION: {
    TITLE: 'Configuración',
    DESCRIPTION:
      'Descarga tu clave pública SSH para configurar esta capacidad. ' +
      'Esta clave se utilizará para escanear los repositorios de código de tu organización.',
    URLS: {
      SETUP: 'Descargar clave pública SSH',
    },
  },
  REPORTS: {
    TITLE: 'Informes',
    DESCRIPTION:
      'Aquí tendrás acceso a un resumen ejecutivo de los resultados del escaneo que ' +
      'describe la postura de seguridad del código de tu organización, además de un informe con ' +
      'los detalles de los hallazgos críticos.',
    DOWNLOAD: {
      Last: 'Descargar último informe',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentación',
    DESCRIPTION:
      'Accede a la documentación para aprender a configurar nuestra capacidad de ' +
      'escaneo de código, así como para entender los informes generados.',
    URLS: {
      GUIDE_BITBUCKET: 'Guía de configuración del escáner de código Qalea para Bitbucket',
      GUIDE_GITHUB: 'Guía de configuración del escáner de código Qalea para GitHub',
      GUIDE_GITLAB: 'Guía de configuración del escáner de código Qalea para GitLab',
    },
  },
  INSIGHTS: {
    TITLE: 'Insights',
    DESCRIPTION:
      'Obtén insights valiosos de tus escaneos de código. Revisa los resultados y ' +
      'descubre acciones recomendadas para fortalecer la seguridad de tu organización ' +
      'enfocándote en el escaneo de código.',
    TRENDS_NOT_YET_AVAILABLE: 'Escaneos de código aún no iniciados',
  },
}
